import React, {useEffect, useState} from "react";
import Layout from "../components/ui/layout";
import {useParams} from "react-router";
import blogAnimation from "../utils/blogSectionAnimation";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const BlogDetail = () => {
    const params = useParams();
    const filePath = "/blog/" + params.id + ".md";

    const [markdownContent, setMarkdownContent] = useState('');

    useEffect(() => {

        fetch(filePath)
            .then(response => response.text())
            .then(text => setMarkdownContent(text))
            .catch(error => console.error('Error fetching Markdown:', error));

        const mq = window.matchMedia("(min-width: 1024px)");
        if (mq.matches) {
            blogAnimation.blogDetailDesktopAnimation();
        } else {
            blogAnimation.mobileAnimation();
        }
    }, [filePath]);

    return (
        <Layout>
            <div className="markdown-body text-start mobile-animation">
                <Markdown remarkPlugins={[remarkGfm]}>{markdownContent}</Markdown>
            </div>
        </Layout>
    )
}
